import { Suspense } from 'react';
import { PageHeader } from 'components/PageHeader';
import { getTrans } from 'modules/i18n';
import { Layout } from 'modules/minimal-ui-theme';
import { LazyCopyTextSuccessToast } from 'modules/modals';
import { DeleteProfileContent } from 'modules/profile';

export const DeleteProfilePage = () => (
  <Layout
    header={
      <PageHeader title={getTrans('deleteProfilePage.title')} withBackBtn />
    }
  >
    <DeleteProfileContent />
    <Suspense>
      <LazyCopyTextSuccessToast />
    </Suspense>
  </Layout>
);
